import { prop } from 'ramda';

import { rolesAdapter } from '@/adapters';

export const rolesEntitySelector = rolesAdapter.getSelectors<RootState>(prop('roles'));